import { RightOutlined } from '@ant-design/icons';
import { Alert, AlertDescription } from 'components/ui/alert';
import posthog from 'posthog-js';
import { usePushNotificationOptIn } from 'push/PushNotificationOptInContext';
import { useNavigate } from 'react-router-dom';
import { routes } from 'services/RouteService';
import Platform from 'utils/Platform';

export type NotificationSuggesterProps = {
  text: string;
};

const NotificationSuggester: React.FC<NotificationSuggesterProps> = ({ text }) => {
  const navigate = useNavigate();
  const { enableNotifications } = usePushNotificationOptIn();

  return (
    <Alert
      variant="info"
      className="cursor-pointer"
      onClick={() => {
        posthog.capture('notification_suggester_clicked');
        if (!Platform.isNative()) {
          navigate(routes.settings.route);
        } else {
          enableNotifications();
        }
      }}
    >
      <AlertDescription className="flex w-full flex-row items-center justify-between gap-2">
        <div>{text}</div>
        <div className="text-2xs">
          <RightOutlined />
        </div>
      </AlertDescription>
    </Alert>
  );
};
export default NotificationSuggester;
